import {
  Button,
  CardContent,
  Checkbox,
  CircularProgress,
  FormControlLabel,
  Grid,
  Typography,
} from '@mui/material';
import { useState, useEffect } from 'react';
import { MonetizationOn } from '@mui/icons-material';
import { useDispatch, useSelector } from 'react-redux';
import SimpleCard from '../../../../../components/SimpleCard';
import WizardButtons from '../WizardButtons';
import PaymentReview from './PaymentReview';
import { createUpdateVendorEvent } from '../../methods';
import agreementDocument from '../../../../../assets/documents/NEW_fayVen_Vendor_Agreement.pdf';
import {
  registerVendorEventSuccess,
  toSetTotalAmountDue,
} from '../../../../../core/vendor-events/action';

// eslint-disable-next-line react/prop-types
export default function Charges({ nextStep, previousStep }) {
  const dispatch = useDispatch();
  const {
    vendorEvents: { vendorEventPayload, currentVendorEvent },
    events: { event },
  } = useSelector((store) => store);
  const [totalAmountDue, setTotalAmountDue] = useState(0);
  const [loading, setLoading] = useState(false);
  const [accepTerms, setAccepTerms] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');

  useEffect(() => {
    if (currentVendorEvent?.space_dimension) {
      const spacePrice = currentVendorEvent?.space_dimension?.cost;
      const amenitiesPrice = vendorEventPayload?.amenities_price || 0;
      setTotalAmountDue(Number(spacePrice) + Number(amenitiesPrice));
    }
  }, [vendorEventPayload?.amenities_price, currentVendorEvent?.space_dimension]);

  useEffect(() => {
    if (currentVendorEvent?.payment_terms_accepted) {
      setAccepTerms(currentVendorEvent?.payment_terms_accepted);
    }
  }, [currentVendorEvent?.payment_terms_accepted]);

  useEffect(() => {
    if (accepTerms) setAlertMessage('');
  }, [accepTerms]);

  const handleChange = (e) => {
    setAccepTerms(e.target.checked);
  };

  const onRegisterVendorEvent = () => {
    if (!accepTerms) {
      setAlertMessage('Accept payment terms is required');
      return;
    }
    setAlertMessage('');
    setLoading(true);
    dispatch(toSetTotalAmountDue(totalAmountDue));
    const type = currentVendorEvent?.status === 'unpaid' ? 'update' : 'create';
    createUpdateVendorEvent(
      {
        ...vendorEventPayload,
        payment_terms_accepted: accepTerms,
      },
      // eslint-disable-next-line prettier/prettier
      type
    )
      .then((data) => {
        dispatch(registerVendorEventSuccess(data));
        nextStep();
        setLoading(false);
      })
      .catch((error) => {
        console.error(error);
        setLoading(false);
      });
  };

  return (
    <div>
      <Grid container justifyContent="center">
        <Grid item>
          <Typography fontWeight="bold">Charges:</Typography>
        </Grid>
        <Grid item>
          <Typography marginLeft={2}>a breakdown of the event charges and fees</Typography>
        </Grid>
      </Grid>
      <SimpleCard variant="outlined">
        <CardContent>
          <Grid container marginBottom={2}>
            <Grid item>
              <Typography fontWeight="bold">Price Breakdown:</Typography>
            </Grid>
            <Grid item>
              <Typography marginLeft={2}>What you are paying for</Typography>
            </Grid>
          </Grid>
          <Grid container justifyContent="center">
            <Grid item xs={5} textAlign="center">
              <Grid container marginBottom={2}>
                <Grid item>
                  <Typography fontWeight="bold">Event space:</Typography>
                </Grid>
                <Grid item>
                  <Typography marginLeft={2}>
                    $ {currentVendorEvent?.space_dimension?.cost} USD
                  </Typography>
                </Grid>
              </Grid>
              <Grid container marginBottom={2}>
                <Grid item>
                  <Typography fontWeight="bold">Amenities:</Typography>
                </Grid>
                <Grid item>
                  <Typography marginLeft={2}>
                    $ {vendorEventPayload?.amenities_price} USD
                  </Typography>
                </Grid>
              </Grid>
              <Grid container marginBottom={2}>
                <Grid item>
                  <Typography fontSize="large" fontWeight="bold">
                    Total amount due:
                  </Typography>
                </Grid>
                <Grid item>
                  <Typography fontSize="large" marginLeft={2}>
                    $ {totalAmountDue} USD
                  </Typography>
                  <div style={{ color: '#5CD0B3', marginTop: '1rem' }}>
                    <MonetizationOn fontSize="large" />
                  </div>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <PaymentReview totalAmountDue={totalAmountDue} />
          <Grid container justifyContent="center">
            <FormControlLabel
              control={
                <Checkbox checked={accepTerms} onChange={handleChange} name="agree_payment" />
              }
              label="I agree to the payment terms listed by fayVen."
            />
          </Grid>
          <Grid container justifyContent="center">
            <a href={agreementDocument} target="_blank" rel="noreferrer">
              Please download and read the following payment terms.
            </a>
          </Grid>
          {alertMessage && (
            <Grid container justifyContent="center">
              <Typography color="#EE7B57">{alertMessage}</Typography>
            </Grid>
          )}
        </CardContent>
      </SimpleCard>

      <WizardButtons
        nextStep={onRegisterVendorEvent}
        loading={loading}
        previousStep={previousStep}
      />
    </div>
  );
}
